import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { LinkTo } from '@ember/routing';

import { pluralize } from '@warp-drive/utilities/string';
import clipboard from 'ember-cli-clipboard/modifiers/clipboard';
import { t } from 'ember-intl';

import Button from 'umg-ember-backend/components/ui/button';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from '../styles.module.css';

const bem = getBem(styles);

<template>
  <p>{{@flash.message}}</p>

  {{#if @flash.data.collisionType}}
    <strong>
      {{t (concat 'models.plurals.' @flash.data.collisionType)}}
    </strong>
    <br />
    {{#each @flash.data.collisions as |collision|}}
      <LinkTo
        @route={{concat
          'admin.'
          (pluralize @flash.data.collisionType)
          '.'
          @flash.data.collisionType
        }}
        @model={{collision.id}}
        target='_blank'
      >
        {{collision.headline}}
        ({{collision.id}})
      </LinkTo>
      <br />
    {{/each}}
  {{/if}}

  <Button
    class={{bem 'button'}}
    @label={{t 'application.flash_messages.api_error.copy'}}
    {{clipboard text=@flash.message}}
  />

  <Button
    class={{bem 'button'}}
    @size='small'
    @label={{t 'application.flash_messages.api_error.close'}}
    {{on 'click' @close}}
  />
</template>
